<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-introduction element-with-heading" epub:type="introduction" id="introduction" role="doc-introduction">
<div class="heading heading-with-title heading-without-image" id="introduction-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Introduction</h1>
</div>
</div>
</div>
</div>
<div class="text" id="introduction-text">
<p class="first first-in-chapter first-full-width">This anthology came about as a group project for my Publishing MA students at the Graduate Program in Creative Writing at Western Colorado University, where I teach. During the summer residency, the nine students brainstormed ideas for an original anthology, and they came up with <i>Monsters, Movies &amp; Mayhem</i> as their favorite. They wrote up their pitch for the book, defined exactly what kind of stories they were looking for.</p>
<p class="subsq">The students sent out a wide call for submissions and received over four hundred stories in the slushpile. They waded through them, weeded out the ones that weren’t ready for prime time, chose the best, and wrote up publication contracts. The wrote rejection letters for all the others. With generous assistance from Draft2Digital and support from Western Colorado University, we were able to pay professional rates for these stories.</p>
<p class="subsq">They waded through them, buried under stories not formatted properly, or that had nothing to do with the anthology subject (one guy sent us a list of tourist sites in Manhattan…and then resubmitted the manuscript after we rejected it!). They needed to weigh hard and visceral stories against light and funny ones, balance the number of werewolf stories against zombie stories or haunted theater stories. After several iterations, they weeded out the ones that weren’t ready for prime time, chose the best, and wrote up publication contracts.</p>
<p class="subsq">They worked with the authors to copy edit and proofread their individual pieces. They designed the cover and the interior, produced the book, and published it in hardcover, paperback, and ebook as their graduation project.</p>
<p class="subsq">Much more than just a class project, though, <i>Monsters, Movies &amp; Mayhem </i>is filled with remarkable stories, some terrifying, some funny, some heart wrenching. Let the lights go down, lean back in your seat, and enjoy them like popcorn.</p>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Kevin J. Anderson, Director, Publishing Program</p>
<p class="alignment-block-content alignment-block-content-right">Graduate Program in Creative Writing</p>
<p class="alignment-block-content alignment-block-content-right">Western Colorado University</p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?4c56c490